export default __webpack_public_path__ + "static/media/SEC2040.34I-43042_-25730_0.ad9bb85e.jpg";